import { render, staticRenderFns } from "./ClinicProfileComponent.vue?vue&type=template&id=1460fddc&scoped=true&"
import script from "./ClinicProfileComponent.vue?vue&type=script&lang=js&"
export * from "./ClinicProfileComponent.vue?vue&type=script&lang=js&"
import style0 from "./ClinicProfileComponent.vue?vue&type=style&index=0&id=1460fddc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1460fddc",
  null
  
)

export default component.exports